import styled from "@emotion/styled"
import Dialog from "@mui/material/Dialog"

const NpsQuestionsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 14px;
  width: 100%;
  padding: 20px 22px 24px;
  border-radius: 24px;
  background: radial-gradient(
      circle at 4% -8%,
      rgba(99, 102, 241, 0.14) 0%,
      transparent 35%
    ),
    radial-gradient(
      circle at 98% 108%,
      rgba(14, 165, 233, 0.12) 0%,
      transparent 42%
    ),
    var(--cms-content-bg);

  .heading-copy {
    display: flex;
    flex-direction: column;
    gap: 6px;
  }

  .page-title {
    margin: 0;
    font-size: 30px;
    font-weight: 800;
    color: var(--cms-text-primary);
    letter-spacing: -0.01em;
  }

  .page-subtitle {
    margin: 0;
    color: var(--cms-text-secondary);
    font-size: 13px;
    font-weight: 500;
  }

  .new-question-btn {
    text-transform: none;
    font-weight: 700;
    border-radius: 10px;
    min-height: 40px;
    padding: 8px 16px;
    box-shadow: 0 12px 24px rgba(37, 99, 235, 0.24);
  }

  .page-surface {
    border: 1px solid var(--cms-border);
    border-radius: 18px;
    background: var(--cms-surface-secondary);
    box-shadow: 0 14px 30px rgba(15, 23, 42, 0.08);
    padding: 14px;
  }

  .page-empty {
    border: 1px dashed var(--cms-border);
    border-radius: 12px;
    background: var(--cms-surface-muted);
    padding: 26px 16px;
    text-align: center;
    color: var(--cms-text-secondary);
    font-weight: 600;
  }

  .question-text-cell {
    max-width: 360px;
    white-space: normal;
    word-break: break-word;
  }

  .tier-chip {
    margin: 2px 4px 2px 0;
  }

  .status-badge {
    font-weight: 700;
  }

  .status-active {
    background: rgba(16, 185, 129, 0.16);
    color: #059669;
  }

  .status-inactive {
    background: var(--cms-surface-muted);
    color: var(--cms-text-secondary);
  }

  .table-empty {
    text-align: center;
    color: var(--cms-text-secondary);
    font-weight: 600;
    padding: 26px 16px;
  }
`

const StyledNpsQuestionDialog = styled(Dialog)`
  .MuiPaper-root {
    width: min(640px, calc(100vw - 28px));
    max-width: none;
    border-radius: 18px;
    border: 1px solid var(--cms-border);
    background: var(--cms-dialog-bg);
    box-shadow: 0 24px 48px rgba(15, 23, 42, 0.2);
  }

  .MuiDialogTitle-root {
    padding: 18px 22px 8px;
  }

  .MuiDialogContent-root {
    display: flex;
    flex-direction: column;
    padding: 10px 22px 10px;
    max-height: min(76vh, 860px);
    overflow: auto;
  }

  .MuiDialogActions-root {
    padding: 8px 22px 18px;
    gap: 10px;
  }

  .dialog-title-group {
    display: flex;
    flex-direction: column;
    gap: 5px;
  }

  .dialog-title {
    margin: 0;
    font-size: 20px;
    font-weight: 800;
    color: var(--cms-text-primary);
    letter-spacing: -0.01em;
  }

  .dialog-subtitle {
    margin: 0;
    font-size: 13px;
    color: var(--cms-text-secondary);
    font-weight: 500;
  }

  .dialog-cancel-btn,
  .dialog-submit-btn {
    text-transform: none;
    border-radius: 10px;
    min-height: 40px;
    font-weight: 700;
    padding: 8px 14px;
  }

  .dialog-submit-btn {
    box-shadow: 0 12px 24px rgba(37, 99, 235, 0.24);
  }

  .MuiFormControl-root {
    margin: 0 0 12px;
    width: 100%;
  }

  .label-text {
    margin: 10px 0 4px;
    font-size: 12px;
    color: var(--cms-text-secondary);
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.04em;
  }

  .error-message {
    min-height: 20px;
    color: #d32f2f;
    font-size: 0.75rem;
    line-height: 1.45;
    margin-bottom: 6px;
  }

  .tier-checkbox-group {
    display: flex;
    flex-wrap: wrap;
    gap: 4px 18px;
    margin-bottom: 8px;
  }

  .active-toggle-row {
    display: flex;
    align-items: center;
    gap: 8px;
    margin: 4px 0 8px;
  }
`

export { NpsQuestionsWrapper, StyledNpsQuestionDialog }
